export const convertToPennies = (value: number): number => value * 100;
export const convertToDollars= (value: number): number => value / 100;

function addMoney(...rest: number[]): number {
  if (arguments.length) {
    const pennies = Array.from(rest).reduce((accumulator, currentValue) => {
      return accumulator + convertToPennies(currentValue);
    }, 0);
    return convertToDollars(pennies)
  }
  return 0;
}

export default addMoney;
